__webpack_require__.p = "/power-pulse/";